import { withRouter } from "react-router";
import { useI18n } from "i18n";
import { RouterLink } from "@remo-co/ui-core/src/components/RouterLink";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useStyles } from "./NavigateToForgetPassword.styles";
import useAuthNavigation from "./hooks/useAuthNavigation";

const NavigateToForgetPassword = () => {
  const classes = useStyles();
  const { t } = useI18n(["auth"]);
  const url = useAuthNavigation("forget-password");

  return (
    <RouterLink to={url} noUnderline data-testid="forget-password-link">
      <Typography component="span" color="primary" className={classes.root}>
        {t("auth:forgot.password")}
      </Typography>
    </RouterLink>
  );
};

export default withRouter(NavigateToForgetPassword);
